import { MediumButton } from "./MediumButton";

interface Props {
  text?: string;
  text1?: string;
  blueCircle?: string;
  photoReplaceFrom?: string;
  className?: string;
  videoUrl?: string;
}

export const ExampleCard = ({
  text = "Couple & Couple",
  text1 = "Season Wedding",
  blueCircle = "/img/bluecircle.svg",
  photoReplaceFrom = "/img/photoreplacefromfill.png",
  className = "",
  videoUrl,
}: Props): JSX.Element => {
  return (
    <div className={`flex flex-col w-56 items-center justify-center gap-9 relative transition-transform duration-250 lg:hover:scale-110 cursor-pointer ${className}`}>
      <img
        className="relative w-[122px] h-[122px]"
        alt="Blue circle"
        src={blueCircle}
      />

      <div className="relative w-[228px] h-[70px] mr-[-4.00px]">
        <div className="absolute w-56 h-10 top-0 left-0 font-examples-cardtitle font-[number:var(--examples-cardtitle-font-weight)] text-[#657d84] text-[length:var(--examples-cardtitle-font-size)] text-center tracking-[var(--examples-cardtitle-letter-spacing)] leading-[var(--examples-cardtitle-line-height)] [font-style:var(--examples-cardtitle-font-style)]">
          {text}
        </div>

        <div className="absolute w-56 h-[30px] top-10 left-0 font-examples-cardlocation font-[number:var(--examples-cardlocation-font-weight)] [font-style:var(--examples-cardlocation-font-style)] text-[#657d84] text-[length:var(--examples-cardlocation-font-size)] text-center tracking-[var(--examples-cardlocation-letter-spacing)] leading-[var(--examples-cardlocation-line-height)]">
          {text1}
        </div>
      </div>

      <MediumButton
        className="!flex-[0_0_auto]"
        property1="default"
        text1="WATCH VIDEO"
        text="WATCH VIDEO"
        videoUrl={videoUrl}
      />
      <img
        className="absolute w-[110px] h-[110px] top-[5px] left-[57px] object-cover"
        alt="Photo replace from"
        src={photoReplaceFrom}
      />
    </div>
  );
}; 